import React, {PropTypes} from 'react';

class Motivation extends React.Component {
  render() {
    return (
      <section>
        <div className="font-size-1">Motivation</div>
        <div className="text">
          <ol>
            <li>Eliminate the need for trial and error during development</li>
            <li>Understand the different techniques to make an element center</li>
            <li>Understand specificity of CSS</li>
          </ol>

        </div>
      </section>
    );
  }
}

export default Motivation;




// WEBPACK FOOTER //
// ./src/motivation/Motivation.jsx